import { isWebResponsive } from '@constants/platform';
import { Colors, Spacing } from '@theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    notificationButton: {
        marginLeft: isWebResponsive ? 0 : Spacing.BIG,
        height: 50,
        width: 50,
        borderRadius: isWebResponsive ? 5 : 25,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: isWebResponsive ? Colors.blackTwo : 'transparent'
    },
    notificationActiveButton: {
        backgroundColor: Colors.socialBackground,
        borderWidth: 2,
        borderColor: Colors.limeGreen
    },
    iconSize: {
        height: 24
    },
    notificationUnreads: {
        position: 'absolute',
        top: 1,
        right: 2,
        borderRadius: 1000,
        minWidth: 24,
        minHeight: 24,
        backgroundColor: Colors.purple,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 4,
    },
});
